import React, {useState} from 'react';
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";

import {AppContext} from "../../HomePage";
import {RequestProbeService} from "../../service/RequestProbeService";

const requestProbeService = new RequestProbeService();

// Reusable "start a Request Probe" launcher used from the Sites step tables
// (monitored + discovered). Creates a product_url or site_search probe for the
// row's site, reusing the request-probe create endpoint. For site_search, a
// reference product (referenceProductId, from discovery) drives the smart
// field-scoring flow; an optional search URL template ({q}) overrides auto-detect.
const ProbeLauncher = ({siteUrl, productUrl, referenceProductId, campaignId, buttonClassName, buttonLabel, buttonTooltip, onStarted}) => {
    const {t, toast, setError} = React.useContext(AppContext);
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState('product_url');
    const [url, setUrl] = useState('');
    const [template, setTemplate] = useState('');
    const [loading, setLoading] = useState(false);

    const typeOptions = [
        {label: 'product_url', value: 'product_url'},
        {label: 'site_search', value: 'site_search'},
    ];

    const defaultUrlFor = (nextType) => {
        if (nextType === 'product_url')
            return productUrl || siteUrl || '';
        return siteUrl || '';   // site_search: site root (auto-detect) or a search-results url
    };

    const open = (e) => {
        if (e) e.stopPropagation();
        setType('product_url');
        setUrl(defaultUrlFor('product_url'));
        setTemplate('');
        setVisible(true);
    };

    const onTypeChange = (value) => {
        setType(value);
        setUrl(defaultUrlFor(value));
    };

    const start = () => {
        if (!url.trim()) return;
        setLoading(true);
        requestProbeService.createProbe(url.trim(), type, null, {
            campaign_id: campaignId,
            product_id: type === 'site_search' ? (referenceProductId || undefined) : undefined,
            search_url_template: type === 'site_search' ? (template.trim() || undefined) : undefined,
        }).then(() => {
            toast.current.show({
                severity: 'success',
                summary: t('onboarding.sites.probeStarted', 'Request probe başlatıldı'),
            });
            setLoading(false);
            setVisible(false);
            if (onStarted) onStarted();
        }).catch(error => {
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    return (
        <span onClick={(e) => e.stopPropagation()}>
            <Button icon="pi pi-bolt" label={buttonLabel} className={buttonClassName || "p-button-text p-button-sm"}
                    style={buttonLabel ? {justifyContent: 'flex-start', width: '100%'} : undefined}
                    tooltip={buttonTooltip || (buttonLabel ? undefined : t('onboarding.sites.startProbe', 'Request Probe başlat'))}
                    tooltipOptions={{position: 'left'}} onClick={open}/>

            <Dialog header={t('onboarding.sites.startProbe', 'Request Probe başlat')} visible={visible}
                    style={{width: '560px', maxWidth: '95vw'}} modal onHide={() => setVisible(false)}
                    footer={
                        <div>
                            <Button label={t('actions.cancel', 'İptal')} className="p-button-text"
                                    onClick={() => setVisible(false)}/>
                            <Button label={t('onboarding.sites.run', 'Çalıştır')} icon="pi pi-play"
                                    onClick={start} disabled={loading || !url.trim()}/>
                        </div>
                    }>
                <div className="p-fluid" style={{display: 'flex', flexDirection: 'column', gap: 14}}>
                    <div>
                        <label style={{display: 'block', marginBottom: 4}}>{t('onboarding.sites.probeType', 'Tip')}</label>
                        <Dropdown value={type} options={typeOptions} onChange={(e) => onTypeChange(e.value)}/>
                    </div>
                    <div>
                        <label style={{display: 'block', marginBottom: 4}}>
                            {type === 'site_search'
                                ? t('onboarding.sites.probeSiteUrl', 'Site URL’i')
                                : t('onboarding.sites.probeProductUrl', 'Ürün URL’i')}
                        </label>
                        <InputText value={url} onChange={(e) => setUrl(e.target.value)}/>
                    </div>
                    {type === 'site_search' &&
                        <div>
                            <label style={{display: 'block', marginBottom: 4}}>
                                {t('onboarding.sites.probeTemplate', 'Arama URL şablonu (opsiyonel, {q})')}
                            </label>
                            <InputText value={template} onChange={(e) => setTemplate(e.target.value)}
                                       placeholder="https://site.com/arama?q={q}"/>
                            <small style={{color: '#6b7280'}}>
                                {referenceProductId
                                    ? t('onboarding.sites.probeRefProduct', 'Referans ürün ile alan-bazlı (isim/kod) aranır; şablon boşsa site otomatik tespit edilir.')
                                    : t('onboarding.sites.probeNoRefProduct', 'Referans ürün yok — URL’i arama-sonuç sayfası olarak girin.')}
                            </small>
                        </div>}
                </div>
            </Dialog>
        </span>
    );
};

export default ProbeLauncher;
